import React from 'react';
import {ConfigureButtonConfiguration, TrackingEvent} from '../types';
import {
  COMPONENT_LIBRARY_ERROR_CODE_MISSING_COMPONENT,
  useComponent,
} from '../component-library';
import {useGetAppDataContentFlag} from '../utils/use-get-app-data-content-flag';
import {AccessibleLabel} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {useTrackingFunctions} from '../contexts/tracking-context';

export interface ConfigureButtonWrapperProps {
  readonly showButton?: boolean;
  readonly configuration?: ConfigureButtonConfiguration;
  readonly translations?: AccessibleLabel;
}

export const ConfigureButtonWrapper = ({
  showButton,
  configuration,
  translations,
}: ConfigureButtonWrapperProps): JSX.Element => {
  const ConfigureButton = useComponent('ConfigureButton');
  const appDataContentHideConfigureButton = useGetAppDataContentFlag(
    'hideConfigureButton'
  );
  const tracking = useTrackingFunctions();

  const handleTracking = (url: string) => {
    const label = translations?.label ?? '';
    tracking[TrackingEvent.BasicButtonClick]?.({
      label,
      link: {
        name: label,
        url,
      },
    });
  };

  return (
    <>
      {!appDataContentHideConfigureButton &&
        showButton &&
        ConfigureButton &&
        ConfigureButton?.displayName !==
          COMPONENT_LIBRARY_ERROR_CODE_MISSING_COMPONENT &&
        configuration &&
        translations && (
          <ConfigureButton
            {...configuration}
            {...translations}
            handleTracking={handleTracking}
          />
        )}
    </>
  );
};
